export const requestNotificationPermission = async (): Promise<void> => {
  if (Notification.permission === "default") {
    await Notification.requestPermission();
  }
};
